(function() {
  'use strict';

  angular.module('layout.sidebar', []);
})();
